import { FC } from "react";

import { ButtonsContainerBase } from "./Containers";
import { ButtonsContainerProps } from "./types";

const ButtonsContainer: FC<ButtonsContainerProps> = (props) => {
  return <ButtonsContainerBase {...props} />;
};

export default ButtonsContainer;
